// extracted by mini-css-extract-plugin
var _1 = "Zuxfy";
var _2 = "kdFMp";
var _3 = "_piqr";
var _4 = "foF5R";
var _5 = "ggqCL";
var _6 = "Kph1S";
var _7 = "T1lje";
export { _1 as "backButton", _2 as "backProduct", _3 as "infoMessage", _4 as "productButton", _5 as "productWrapperExtendedFooter", _6 as "productWrapperExtendedHeader", _7 as "productWrapperList" }
